import { IExperiment } from '../api/experiments';

export const AB_NEWBUILDING_FEATURES = 'promotion_of_newbuilding_features';
export const AB_NEWBUILDING_FEATURES_GROUP = 1;

export const isAbExperimentNewBuildingFeatures = (experiments: IExperiment[]): boolean => {
  const experiment = experiments.find(exp => exp.name === AB_NEWBUILDING_FEATURES);

  return Boolean(experiment && experiment.abGroup === AB_NEWBUILDING_FEATURES_GROUP);
};
